interface LocalCache<T> {
  until: number;
  data: T;
}

export const saveCache = <T>(key: string, data: T, ms: number): void => {
  const now = Date.now();
  const c: LocalCache<T> = {
    until: now + ms,
    data,
  };
  localStorage.setItem(key, JSON.stringify(c));
};

export const loadCache = <T>(key: string): T | void => {
  const jsdata = localStorage.getItem(key);
  if (!jsdata) return;
  const c = JSON.parse(jsdata) as LocalCache<T>;
  if (Date.now() < c.until) return c.data;
  return;
};

export const clearCache = (key: string): void => {
  localStorage.removeItem(key);
};

export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
